import { render } from "./descriptionComponent.vue?vue&type=template&id=b86b92d6&scoped=true"
import script from "./descriptionComponent.vue?vue&type=script&lang=js"
export * from "./descriptionComponent.vue?vue&type=script&lang=js"

import "./descriptionComponent.vue?vue&type=style&index=0&id=b86b92d6&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b86b92d6"]])

export default __exports__